exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.episode-desc a {\n  color: #999;\n  text-decoration: none;\n  opacity: 1;\n  transition: opacity 0.15s ease-in;\n}\n.episode-desc a:hover {\n  opacity: 0.5;\n  transition: opacity 0.15s ease-out;\n}\n.h-45 {\n  height: 45vh;\n}\n.h-90 {\n  height: 90vh;\n}\n.h-35p {\n  height: 32px;\n}\n.h-20 {\n  max-height: 20vh;\n}\n.custom-position {\n  top: 4px;\n}\n.custom-npl-position {\n  top: 38px;\n}\n.shadow-5 {\n  box-shadow: 20px 20px 20px 20px rgba(0, 0, 0, 0.2);\n}\n.w-45 {\n  width: 48.9%;\n}\n", ""]);

// exports
